module.exports = __webpack_public_path__ + "img/icon_delete_his.0b9144b8.svg";